import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Button from 'shopper/components/Button';
import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import SocialMediaLoginButtonsGroup from 'components/SocialMediaLoginButtonsGroup';

import useDialog from 'hooks/useDialog';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import Disclaimer from './Disclaimer';

const LoginDialog = dynamic(() => import('components/LoginDialog'), {
  ssr: false,
});

const SignInCard = ({ className, gaEventCategory }) => {
  const { showDialog } = useDialog();

  const onSignUpClick = () => {
    sendEvent({ action: 'modal_login', category: gaEventCategory });
    showDialog(LoginDialog);
  };

  return (
    <Box
      className={twMerge(
        'flex flex-col items-center justify-between gap-4 rounded-4 p-4',
        className
      )}
    >
      <Text className="text-center">
        {placeholder('descriptions.signInOptions')}
      </Text>
      <div className="flex w-full flex-col items-center gap-3">
        <SocialMediaLoginButtonsGroup gaEventCategory={gaEventCategory} />
        <Button
          className="w-full rounded-3 border border-neutral-high-300"
          size="size4"
          type="neutral-ghost"
          onClick={onSignUpClick}
        >
          <Icon name="email" />
        </Button>
      </div>
      <Disclaimer />
    </Box>
  );
};

SignInCard.propTypes = {
  className: PropTypes.string,
  gaEventCategory: PropTypes.string.isRequired,
};

export default SignInCard;
